import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon(/*#__PURE__*/ _jsx("path", {
    fill: "currentColor",
    d: "M12.2222 6.4445a2.2222 2.2222 0 1 0 0-4.4444 2.2222 2.2222 0 0 0 0 4.4444m0 11.1111a2.2222 2.2222 0 1 0 0 4.4445 2.2222 2.2222 0 0 0 0-4.4445m0-7.7778a2.2223 2.2223 0 1 0 0 4.4446 2.2223 2.2223 0 0 0 0-4.4446"
}), "EllipsisVertical", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
